export const auth = {
  state: {
    status: "",
    token: localStorage.getItem("token") || "",
    user: {},
    admin: false,
    superAdmin: false,
    maxUsers: 0,
    level: 3,
    companyState: null,
    trialDays: 0,
    tour: true,
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, token) {
      state.status = "success";
      state.token = token;
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.user = {};
      state.admin = false;
      state.superAdmin = false;
      state.maxUsers = 0;
      state.level = 3;
    },
    setUser(state, user) {
      state.user = user;
    },
    setMaxUsers(state, maxUsers) {
      state.maxUsers = maxUsers;
    },
    setAdmin(state, bool) {
      state.admin = bool;
    },
    setSuperAdmin(state, bool) {
      state.superAdmin = bool;
    },
    setLevel(state, level) {
      state.level = level;
    },
    setTour(state, bool) {
      state.tour = bool;
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    admin: state => state.admin,
    user: state => state.user,
    superAdmin: state => state.superAdmin,
    maxUsers: state => state.maxUsers,
    level: state => state.level,
    companyState: state => state.companyState,
    trialDays: state => state.trialDays,
  }
};
